import { fetchAemContent } from "@/services/aem";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getFaqData = createAsyncThunk("/aem/getFaqData", async () => {
  const res = await fetchAemContent(
    `/content/empire/${process.env.NEXT_PUBLIC_MERCHANT_IDENTIFIER}/en/entertaining/faq.model.json`
  );
  return res;
});
